import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const processed = useRef(false);
  const nav = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        toast.success("Accesso con Google effettuato");
        nav("/dashboard", { replace: true });
      } catch (err) {
        const d = err?.response?.data?.detail;
        toast.error(typeof d === "string" ? d : "Accesso Google non riuscito");
        setUser(false);
        nav("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="min-h-screen flex items-center justify-center text-slate-500 gap-2" data-testid="auth-callback"><Loader2 className="animate-spin" size={18} /> Accesso in corso…</div>;
}
